import { ContextOrderBasketType } from "../../../../../hooks";

export const formattedOrderItemList = (
  orderItems: ContextOrderBasketType["OrderItems"],
) => {
  return (
    orderItems?.map((item) => {
      return {
        ...item,
        containerType: item.Product.containerType ?? null,
        unit: item.Product.unit ?? null,
        volume: item.Product.volume ?? 0,
        packQuantity: item.Product.packQuantity ?? 0,
      };
    }) ?? []
  );
};
